import reducer from './reports.reducer';
import actions from './reports.actions';
import selectors from './reports.selectors';

export default {
  reducer,
  actions,
  selectors,
};
